<template>
    <UFieldGroup>
        <UButton
            class="justify-center"
            variant="soft"
            :disabled="prevDisabled"
            @click="prev"
        >
            <UIcon name="i-ph-caret-left"/>
        </UButton>
        <slot v-for="year in years" :key="year.value" :year="year">
            <UButton
                class="w-full justify-center"
                :disabled="year.disabled"
                :active="year.selected"
                active-variant="solid"
                variant="soft"
                :data-col="year.label"
                @click="year.onClick"
            >
                {{ year.label }}
            </UButton>
        </slot>
        <UButton
            class="justify-center"
            variant="soft"
            :disabled="nextDisabled"
            @click="next"
        >
            <UIcon name="i-ph-caret-right"/>
        </UButton>
    </UFieldGroup>
</template>
<script setup lang="ts">

import {useYearMatrix} from '@/dateUtils/v2/useYearMatrix'
import {DateRange} from '@/dateUtils/DateRange'

const range = defineModel<DateRange>({required: true})
const props = defineProps<{
    isDisabled?: (range: DateRange) => boolean
}>()

const {years, next, prev, nextDisabled, prevDisabled} = useYearMatrix(range, props.isDisabled)

</script>

<style scoped>

</style>